export enum DocumentView {
  DOCUMENT = 'document',
  MARKDOWN = 'markdown',
}

export enum DocumentLayout {
  DIRECTORY = 'directoryView',
  DETAIL = 'detailView',
}
